import './InfoCard.css';
import * as React from 'react'

export default function InfoCard (props) {
  return (
    <div className="info-card-style">
      <img className='info-card-icon' src={props.image} />
      <h2>{props.title}</h2>
      <p>{props.content}</p>
    </div>
  )
}

